export default __webpack_public_path__ + "static/media/fila-espera-timeout.838742d4.mp3";